<template>
   <footer class="footer">
     <div class="container">
       <div class="content has-text-centered">
         <p>
           (c) <strong>Atelier Poramora</strong> 2018
         </p>
         <p>
           <a class="icon" href="https://twitter.com/neolivros">
             <i class="fa fa-twitter"></i>
           </a>
           <a class="icon" href="">
             <i class="fa fa-facebook"></i>
           </a>
         </p>
         <!-- PayPal Logo -->
         <p class="paypal has-text-centered">
         <a href="https://www.paypal.com/webapps/mpp/paypal-popup" title="How PayPal Works" onclick="javascript:window.open('https://www.paypal.com/webapps/mpp/paypal-popup','WIPaypal','toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=1060, height=700'); return false;"><img src="https://www.paypalobjects.com/webstatic/mktg/logo/AM_mc_vs_dc_ae.jpg" border="0" alt="PayPal Acceptance Mark"></a>
         </p>
         <!-- PayPal Logo -->
       </div>
     </div>
   </footer>
</template>

<script>
import { categoriesRef } from '../firebase_config'
export default {
  name: 'foot',
  // mounted: function () {
  // },
  firebase: {
    categories: {
      source: categoriesRef,
      asObject: false
    }
  }
}
</script>

<style lang="scss" scoped>
.paypal img {
  width:180px;
}
</style>



// WEBPACK FOOTER //
// src/components/Foot.vue